export const AVATAR_SIZE = 30;
export const PADDING = 8;
export const BASE_WIDTH_DRAWER = 230;
export const SMALL_WIDTH_DRAWER = 50;
export const NORMAL_SIZE_DRAWER = BASE_WIDTH_DRAWER + PADDING * 2;
export const SMALL_SIZE_DRAWER = SMALL_WIDTH_DRAWER + PADDING * 2;
export const TOOLBAR_BACKGROUND_COLOR = '#002438';
